import { AlertCircle } from "lucide-react";
import Confetti from "react-confetti-boom";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

import Link from "next/link";
import { useEffect } from "react";
import { BLOCK_EXPLORER_URL } from "../constants";
import { useStore } from "./store";

const PaymentConfirmation = () => {
  const { transactionId, isFailedRegistration } = useStore();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-[500px]">
      <Confetti />
      <div className="text-center max-w-2xl mx-auto space-y-6">
        <h2 className="text-3xl font-bold text-white">Thank You for Your Purchase! 🎉</h2>

        <p className="text-lg">
          Your KOLZ AI Agent is now in motion! You&apos;re taking your community to the next level with 24/7 AI-powered
          moderation and engagement from the top Key Opinion Leaders in the space.
        </p>

        {isFailedRegistration && (
          <Alert variant="destructive" className="bg-red-900 text-white text-left">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Note</AlertTitle>
            <AlertDescription>
              The transaction went through, but there was an error registering your payment. Please contact us at{" "}
              <a
                href={`mailto:contact@kolz.chat?subject=Payment registration problems&body=Hello, there was a problem rgistering the payment. Here is the transaction link: ${BLOCK_EXPLORER_URL}/tx/${transactionId}`}
                className="font-bold underline hover:text-red-200"
              >
                contact@kolz.chat
              </a>{" "}
              to start the setup process.
            </AlertDescription>
          </Alert>
        )}

        <div className="bg-purple-150 p-6 rounded-lg">
          <h3 className="font-semibold text-xl mb-4">What&apos;s Next?</h3>
          <ul className="space-y-3 text-left list-none">
            <li className="flex items-center gap-2">
              <span className="text-purple-600">✓</span> A KOLZ team member will reach out within 48 hours to start
              training your AI Agent
            </li>
            <li className="flex items-center gap-2">
              <span className="text-purple-600">✓</span> Get ready for seamless, automated support in your Discord and
              Telegram
            </li>
          </ul>
        </div>

        <p className="text-gray-300">
          If you have any questions in the meantime, please reach us at{" "}
          <a href="mailto:contact@kolz.chat" className="text-white underline">
            contact@kolz.chat
          </a>
        </p>

        <div>
          <Link
            href={`${BLOCK_EXPLORER_URL}/tx/${transactionId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-4 py-2 rounded-md bg-blue-500 text-white hover:bg-blue-600 transition-colors"
          >
            Check transaction on Etherscan
          </Link>
          <p className="text-sm text-gray-200 mt-4">
            Please note that the transaction may take a few minutes to complete. <br /> Save{" "}
            <a
              href={`${BLOCK_EXPLORER_URL}/tx/${transactionId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              this link
            </a>{" "}
            for any communication with our team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentConfirmation;
